import { render } from "./FormWishesView.vue?vue&type=template&id=506a9cde"
import script from "./FormWishesView.vue?vue&type=script&lang=js"
export * from "./FormWishesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__